module.exports = __webpack_public_path__ + "static/media/success(8).4078224b.png";